import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";

export type LocalDropboxPreferences = { localDropboxRootPath?: string | null };

export const localDropboxPreferencesKey = (userId: number | null) =>
  ["/api/user/preferences", "local-dropbox-root", userId] as const;

/** Identity-scoped cache; never borrow another account's local filesystem path. */
export function useLocalDropboxRoot(userId: number | null, enabled: boolean) {
  return useQuery<LocalDropboxPreferences>({
    queryKey: localDropboxPreferencesKey(userId),
    enabled: enabled && userId !== null,
    queryFn: async ({ signal }) => {
      const response = await apiRequest("GET", "/api/user/preferences");
      const preferences = await response.json() as LocalDropboxPreferences;
      signal.throwIfAborted();
      return preferences;
    },
    // Stable account setting: reuse across menus and row remounts until a save
    // updates this cache, an explicit refresh, or the app is reloaded.
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  });
}